import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from '../../../../node_modules/prop-types/index.js';
import i18n from '../../../lang/i18n/index.js';
import { safeRest } from '../../../utils/functions.js';
import safeCustomStyle from '../../../utils/safeCustomStyle.js';
import { Root, ExpandedWrapper, TextButton } from './styledComponents.js';
import useLang from '../../../hooks/useLang.js';
import useTheme from '../../../hooks/useTheme.js';
import useToggle from '../../../hooks/useToggle.js';

var _excluded = ["collapsedContent", "expandedContent", "showMoreButtonAriaLabel", "showLessButtonAriaLabel", "customStyle"];

var ExpandableParagraphExperimental = function ExpandableParagraphExperimental(_ref) {
  var collapsedContent = _ref.collapsedContent,
      expandedContent = _ref.expandedContent,
      showMoreButtonAriaLabel = _ref.showMoreButtonAriaLabel,
      showLessButtonAriaLabel = _ref.showLessButtonAriaLabel,
      customStyle = _ref.customStyle,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _safeCustomStyle = safeCustomStyle(customStyle),
      rootStyle = _safeCustomStyle.rootStyle,
      buttonStyle = _safeCustomStyle.buttonStyle;

  var safeProps = safeRest(rest);
  var lang = useLang();
  var theme = useTheme();

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      expanded = _useToggle2[0],
      toggleExpanded = _useToggle2[1];

  return /*#__PURE__*/React.createElement(Root, _extends({
    rootStyle: rootStyle,
    theme: theme
  }, safeProps), collapsedContent, "\xA0", expanded && /*#__PURE__*/React.createElement(ExpandedWrapper, null, expandedContent), /*#__PURE__*/React.createElement(TextButton, {
    type: "button",
    theme: theme,
    onClick: toggleExpanded,
    "aria-label": expanded ? showLessButtonAriaLabel : showMoreButtonAriaLabel,
    buttonStyle: buttonStyle
  }, expanded ? i18n[lang].expandableParagraph.showLess : i18n[lang].expandableParagraph.showMore));
};

process.env.NODE_ENV !== "production" ? ExpandableParagraphExperimental.propTypes = {
  /** content to always show */
  collapsedContent: PropTypes.node.isRequired,

  /** content to show when expanded */
  expandedContent: PropTypes.node.isRequired,

  /** Aria-label for 'show more' button */
  showMoreButtonAriaLabel: PropTypes.string.isRequired,

  /** Aria-label for 'show less' button */
  showLessButtonAriaLabel: PropTypes.string.isRequired,

  /** override for styling */
  customStyle: PropTypes.shape({
    rootStyle: PropTypes.object,
    buttonStyle: PropTypes.object
  })
} : void 0;
ExpandableParagraphExperimental.defaultProps = {
  customStyle: {
    rootStyle: {},
    buttonStyle: {}
  }
};
process.env.NODE_ENV !== "production" ? ExpandableParagraphExperimental.displayName = 'ExpandableParagraphExperimental' : void 0;
var ExpandableParagraphExperimental$1 = ExpandableParagraphExperimental;

export { ExpandableParagraphExperimental$1 as default };
